// require('./bootstrap');
import intlTelInput from "intl-tel-input";
window.intlTelInput = intlTelInput;
import sort from '@alpinejs/sort'

Alpine.plugin(sort)

import Alpine from "alpinejs";
window.Alpine = Alpine;
Alpine.start();


document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener("click", function (e) {
        e.preventDefault();

        document.querySelector(this.getAttribute("href")).scrollIntoView({
            behavior: "smooth",
        });
    });
});
